/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation, useQuery } from '@tanstack/react-query'
import { useEffect, useLayoutEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { googleAccountClientId } from '../../constants/general'
import { ApiActivity } from '../../services/api'
import { GetApiToken } from '../../services/Auth'
import { GetUserProfile } from '../../services/User'
import extractRedirectSuccessFromUrl from '../../utils/getDataFromUrl'
import { getTokenLocalStorage, setTokenLocalStorage, setUserLocalStorage } from '../../utils/localStorage'
import { Page, Title } from './styles'

export default function Login() {
    document.title = 'Justpoint - CRM | Login'

    const location = useLocation()
    const navigate = useNavigate()
    let scheduled = false

    const localToken = getTokenLocalStorage()

    const { data } = useQuery(['userProfile'], () => GetUserProfile(), {
        retry: false,
        onSuccess: () => {
            keepUserOnline()
        },
        staleTime: 60 * 60000
    })

    const keepUserOnline = () => {
        setInterval(() => {
            if (scheduled) {
                ApiActivity.post('last_active', {})
            }
        }, 30000)
        scheduled = true
    }

    const redirect = () => {
        const redirectString = extractRedirectSuccessFromUrl(location.search)
        if (!redirectString || redirectString === '/') {
            navigate('/case-list/assigned-cases')
        } else {
            navigate(redirectString)
        }
    }

    const getToken = useMutation(GetApiToken, {
        onError: (error: any) => {
            console.log(error)
        },
        onSuccess: (data) => {
            setTokenLocalStorage(data.token)
        }
    })

    const getUserData = !!localToken

    const { data: userProfile } = useQuery(['userProfile'], () => GetUserProfile(), {
        enabled: getUserData,
        onSuccess: (data: any) => {
            setUserLocalStorage(data.data)
        },
        staleTime: 60 * 60000
    })

    const userIsLogged = !!data && !!userProfile

    async function handleCredentialResponse(response: any) {
        await getToken.mutate({ token: response.credential })
    }

    useEffect(() => {
        if (userIsLogged) redirect()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userIsLogged])

    useLayoutEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://accounts.google.com/gsi/client'
        script.onload = () => {
            window.google.accounts.id.initialize({
                client_id: googleAccountClientId,
                callback: handleCredentialResponse
            })
            const signInDiv = document.getElementById('signinDiv')
            if (signInDiv) {
                window.google.accounts.id.renderButton(signInDiv, {
                    type: 'standard',
                    theme: 'outline',
                    size: 'large'
                })
            } else {
                console.error('Sign-in button element not found')
            }
        }
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Page>
                <img src="/images/logo.png" alt="Justpoint Logo" />
                <Title>Welcome to Justpoint CRM!</Title>
                <div id="signinDiv"></div>
            </Page>
        </>
    )
}
